import React, { useState , useCallback, useEffect} from "react";
import FilterInput from "components/Form/filterInput"
import { Tag } from 'antd';

import {  useSelector } from 'react-redux';
import { toTitleCase } from "utils/common";
import { useSearchParams } from 'react-router-dom';
import {format} from "date-fns"
import {primaryColor} from "utils/constants";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';

import { Button } from "components/Button";


const DocumentListFilter = ({handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading, storeType, setStoreType}) => {
  const {
    department, departmentLoading,
    reportTo, reportToLoading,
    nationality, nationalityLoading,
    position, positionLoading,
    division, divisionLoading,
    costCenter, costCenterLoading
} = useSelector((state) => state.common);

const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([])


  const setInputValue = useCallback((key) => {

   console.log(filters, "---filters in setinputvalueeeeeee")
    if(filters.length){
      let selectedValue = [...filters].find(item=> item.key === key)
      return selectedValue?.value
    }else{
      return ""
    }
  
  }, [filters]);

    useEffect(()=>{
      console.log('useEffeeect')
    if(!departmentLoading && !reportToLoading && !nationalityLoading && !positionLoading && !divisionLoading && !costCenterLoading){

      console.log(filters, "LLLs")

      let _appliedFilters = [...filters].map(item=>{
        let label = ""
        let value = ""
        switch(item.key){
          case "issue_date_after":
            let date = toTitleCase(searchParams.get("issue_date_after") || "")
            let date_formatted = ""
            if(date){
              date_formatted = format(searchParams.get("issue_date_after"), "yyyy-MM-dd")
            }
            value = date_formatted
            label = "Issued after"
            break;
          case "issue_date_before":
            let date_before = toTitleCase(searchParams.get("issue_date_before") || "")
            let date_formatted_before = ""
            if(date_before){
              date_formatted_before = format(searchParams.get("issue_date_before"), "yyyy-MM-dd")
            }
            value = date_formatted_before
            label = "Issued before"
            break;
            case "expiry_date_before":
            let expiry_date_before = toTitleCase(searchParams.get("expiry_date_before") || "")
            let date_formatted_expirybefore = ""
            if(expiry_date_before){
              date_formatted_expirybefore = format(searchParams.get("expiry_date_before"), "yyyy-MM-dd")
            }
            value = date_formatted_expirybefore
            label = "Expiry before"
            break;
            case "expiry_date_after":
              let expiry_date_after = toTitleCase(searchParams.get("expiry_date_after") || "")
              let date_formatted_expiryafter = ""
              if(expiry_date_after){
                date_formatted_expiryafter = format(searchParams.get("expiry_date_after"), "yyyy-MM-dd")
              }
              value = date_formatted_expiryafter
              label = "Expiry after"
              break;
            case "document_type":
              let document_type = toTitleCase(searchParams.get("document_type") || "")
            
              value = document_type
              label = "Document Type"
              break;
            case "company_user":
              let company_user = toTitleCase(searchParams.get("company_user") || "")
            
              value = company_user
              label = "User"
              break;
            case "search":
              value = toTitleCase(searchParams.get("search") || "")
              label = "Search term"
              break;
            case "cost_center":
              let cost_center = toTitleCase(searchParams.get("cost_center") || "")
              value = cost_center
              label = "Cost Center"
              break;
          default:
            label = ""
            value = ""
        }
        return {
          ...item,
          value,
          label
        }
      })
      setAppliedFilters(_appliedFilters.filter(item=> item.value && item.key != "search"))

  
    }

 
  },[
    department,
    reportTo,
    nationality,
    position,
    division,
    searchParams,
    costCenter
  ])


  const handleClose = (e, item) => {
    console.log(item, "llll")
    e.preventDefault();
    if(item.key == "search" || item.key == "issue_date_after" || item.key == "issue_date_before" || item.key == "expiry_date_before" || item.key == "expiry_date_after" || item.key == "cost_center"){
      handleInputChange("", item.key, true)
    }else{
      handleFilterChange("", item.key, true)
    }
  }
  return (
    <div>
      <div className="row filter-row mb-4">
        <div className="col-9 ">
          <div className="row" >
          <div className='col-sm-12 col-lg-4  ' >
        <FilterInput  
         defaultValue={setInputValue("search")} 
         onChange={e=>{handleInputChange(e.target.value, "search", true)}} 
          id="search"
           label={searchPlaceholder}
            />
        </div>
        <div className='col-sm-12  col-lg-8  mt-1 flex-wrap' >
          
        {
            appliedFilters.map(item=>{
              return (
                <Tag icon={loading&&<i class="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>} className="mb-1" color={"red"} closeIcon={<i class="fa fa-times" aria-hidden="true"></i>} onClose={e=>handleClose(e, item)}>
                  {
                    item?.label
                  }
                  {item.label && " : "}
                  {item?.value}
                </Tag>
              )
            })
          }

        </div>
          </div>


      
        </div>
      
 
        <div className="col-3 d-flex justify-content-end">
        {/* <div className="view-icons">
        <Button onClick={()=> {setStoreType(storeType=="user"? "store": "user")}}   icon={storeType=="user" ?"las la-store" : "las la-user"} 
        // id="collapse-header"
         className="list-view btn btn-link "/>
        </div> */}
        <div className="view-icons">
        <Button onClick={handleFilterDrawer} icon="las la-filter"
        //  id="collapse-header" 
         className="list-view btn btn-link "/>
        </div>
       
        </div>
      </div>
    </div>
  );
};

export default DocumentListFilter;
